import React from 'react'
import Card from '@material-ui/core/Card'
import { connect } from 'react-redux'
import {
  SimpleForm,
  TextInput,
  NumberInput,
  SelectInput,
  SelectArrayInput,
  LongTextInput,
  FormDataConsumer,
  Toolbar,
  SaveButton,
  showNotification
} from 'react-admin'
import { change } from 'redux-form'

import Button from '@material-ui/core/Button'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash } from '@fortawesome/free-solid-svg-icons'

import './styles.css'
import auctionService from '../../auctions/auctionService'
import { approvedOptions } from '../../lots/options'
import KindFetch from '../kindFetch'
import offerBoardService from '../offerBoardService'

// react-admin gives every record form this name
const RECORD_FORM = 'record-form'

const locations = auctionService.locations
const auctionPublic = auctionService.auctionPublic

const validateOfferBoard = (values) => {
  const errors = {}
  if (!values.title) {
    errors.title = ['The title is required']
  }
  if (!values.kindIds || values.kindIds.length === 0) {
    errors.kindIds = ['At least one Category is required']
  }
  if (!values.location || !values.location.state || values.location.state.length === 0) {
    errors.location = {}
    errors.location.state = ['The Location State field is required']
  }
  // every chosen category carries its own expiry
  const listingExpiryDays = values.listingExpiryDays || {};
  (values.kindIds || []).forEach(kindId => {
    if (!listingExpiryDays[kindId]) {
      errors.listingExpiryDays = {
        ...errors.listingExpiryDays,
        [kindId]: ['Listing Expiry Days field is required']
      }
    }
  })
  return errors
}

// An Offer Board holds several categories at once and each of them stays on
// the Livestock Exchange for its own number of days, so picking a category adds
// an expiry input for it. The stock type sets the suggested default (28 days
// cattle, 10 days sheep/lambs and goats) and the admin can still override it.
const OfferBoardCategories = (props) => {
  let { kinds } = props
  return (
    <FormDataConsumer>
      {({ formData, dispatch }) => {
        const chosenKinds = ((formData && formData.kindIds) || [])
          .map(kindId => kinds.find(kind => kind.id === kindId))
          .filter(Boolean)

        const updateExpiryDays = (event, value) => {
          const chosen = (value || [])
            .map(kindId => kinds.find(kind => kind.id === kindId))
            .filter(Boolean)
          const current = (formData && formData.listingExpiryDays) || {}
          dispatch(change(RECORD_FORM, 'listingExpiryDays',
            offerBoardService.getExpiryDaysMap(chosen, current)))
        }

        return (
          <>
            <SelectArrayInput source='kindIds' label='Category' choices={kinds} optionText='title' optionValue='id'
              onChange={updateExpiryDays} />
            {chosenKinds.map(kind => (
              <NumberInput key={kind.id} source={`listingExpiryDays.${kind.id}`} step={1}
                label={`${kind.title} Listing Expiry (days listings appear for)`} />
            ))}
          </>
        )
      }}
    </FormDataConsumer>
  )
}

const errorMessage = offerBoardService.errorMessage

// react-admin's default toolbar adds a Delete of its own, which deletes the
// `offer-board` resource - a route the API does not have. This toolbar deletes
// the board through its own endpoint instead.
const OfferBoardToolbar = (props) => {
  let { onDelete, onCancel, ...rest } = props
  return (
    <Toolbar {...rest}>
      <SaveButton />
      {onCancel &&
        <Button className='offer-board-cancel' onClick={onCancel}>
          Cancel
        </Button>}
      {onDelete &&
        <Button className='offer-board-delete' onClick={onDelete}>
          <FontAwesomeIcon icon={faTrash} />
          <span className='offer-board-delete-text'>Delete Offer Board</span>
        </Button>}
    </Toolbar>
  )
}

export const OfferBoardCreateView = (props) => {
  let { offerBoard, onSaved, onDeleted, onCancel, showNotification } = props
  const { kinds } = KindFetch()

  const save = async (values) => {
    try {
      const saved = await offerBoardService.saveOfferBoard(values, offerBoard)
      showNotification(offerBoard
        ? 'Offer Board was successfully updated'
        : 'Offer Board was successfully created', 'success')
      onSaved(saved)
    } catch (err) {
      showNotification(errorMessage(err), 'warning')
    }
  }

  const remove = async () => {
    if (!window.confirm('Delete this Offer Board? Its offers and its listings are taken off it.')) {
      return
    }
    try {
      await offerBoardService.deleteOfferBoard(offerBoard.id || offerBoard._id)
      showNotification('Offer Board was deleted', 'success')
      onDeleted()
    } catch (err) {
      showNotification(errorMessage(err), 'warning')
    }
  }

  return (
    <Card className='offer-board-create'>
      <SimpleForm
        toolbar={<OfferBoardToolbar onDelete={offerBoard ? remove : null} onCancel={onCancel} />}
        record={offerBoard || {}}
        resource='offer-board'
        basePath='/offer-board'
        redirect={false}
        validate={validateOfferBoard}
        save={save}>
        <TextInput source='title' />
        <OfferBoardCategories kinds={kinds} />
        <SelectInput defaultValue={false} source='approved' label='Approved' choices={approvedOptions} />
        <SelectArrayInput source='location.state' label='Location State' choices={locations} />
        <SelectInput source='public' choices={auctionPublic} defaultValue />
        <LongTextInput label='Admin Notes' source='adminNotes' />
      </SimpleForm>
    </Card>
  )
}

export const OfferBoardCreate = connect(null, { showNotification })(OfferBoardCreateView)
